import { render } from "./PayException.vue?vue&type=template&id=7a593163&ts=true"
import script from "./PayException.vue?vue&type=script&lang=ts"
export * from "./PayException.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__